import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";

import { FormBuilder, FormGroup } from "@angular/forms";
import { AuthUserService } from "@app/auth/services/auth-user.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { emailValid } from "../../../shared/validators";
import { Params } from "@angular/router";
import { RouterService } from "@app/root-store/router.service";

@Component({
    selector: "app-forgot-password",
    templateUrl: "./forgot-password.component.html",
    styleUrls: ["./forgot-password.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordComponent {
    form = this.formBuilder.group({
        email: ["", emailValid],
    });

    public queryParams$: Observable<Params> = this.routerService.getQueryParams().pipe(tap(this.updateForm(this.form)));

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly authUserService: AuthUserService,
        private readonly cdr: ChangeDetectorRef,
        private readonly routerService: RouterService
    ) {}

    isPending$ = this.authUserService.selectPendingSignInState$().pipe(
        tap(isPending => {
            if (isPending) {
                this.form.enable();
            } else {
                this.form.disable();
            }
            this.cdr.markForCheck();
        })
    );
    errorMessage$ = this.authUserService.selectSignInError$();

    resetPassword() {
        if (this.form.valid) {
            this.cancel();
            this.authUserService.resetPassword(this.form.value);
        }
    }

    cancel() {
        this.authUserService.clearLoginErrorState();
    }

    private updateForm(form: FormGroup): (params: Params) => void {
        return (params: Params) => {
            if (params?.emailExists === "true") {
                form.patchValue({
                    email: params?.email,
                });
            }
        };
    }
}
